export const UNIDENTIFIED = "UNIDENTIFIED";
export const TUPAS = "TUPAS";
export const OP = "OP";

export const PERSON = "PERSON";
export const BUSINESS = "BUSINESS";

export const INITIAL_VALUE = {
  value: "",
  included: false,
  required: true,
  error: false,
  dirty: false,
};

export const FI = "fi";
export const EN = "en";

export const TEL = "tel";
export const STREET_ADDRESS = "street-address";
export const POSTAL_CODE = "postal-code";

export const EMPTY_ERROR_CODE = "empty";
export const INVALID_TEXT_AREA_ERROR_CODE = "invalidTextArea";
export const INVALID_TEXT_FIELD_ERROR_CODE = "invalid";

export const PHONE = "phone";
export const EMAIL = "email";
export const WEB_MESSAGE = "web_message";
export const CONTACT_METHODS = {
  UNIDENTIFIED: [PHONE, EMAIL],
  TUPAS: [PHONE, EMAIL],
  PERSON: [WEB_MESSAGE, PHONE],
  BUSINESS: [WEB_MESSAGE, PHONE],
};

export const INVALID_EMAIL_CHARS = [
  "<",
  ">",
  ")",
  "(",
  ";",
  "/",
  '"',
  "'",
  "‘",
  "’",
  "“",
  "”",
];

export const MAX_ERROR_COUNT = 3;

export const HA = "HA";
export const YA = "YA";

export const SOURCE = "ilmoita_ongelmasta";
export const CASE_TYPE = "pankkipalaute";
export const FEEDBACK_SUB_TYPE = "negative";

export const ASSIGNEE_GROUPS = {
  personalFeedback: "personal", // Henkilöasiakkaiden palautekäsittely
  corporateFeedback: "business", // Yritysasiakkaiden palautekäsittely
  insuranceFeedback: "insurance_web", // Vakuutuksen verkkopalvelun palautekäsittely
};

export const TOPIC_PREFIX = "Op.fi:";

export const OP_BUSINESS_MOBILE = "report_issue_op_business_mobile";
export const FEEDBACK_SUBJECTS = [
  "report_issue_web_service",
  "report_issue_op_mobile",
  OP_BUSINESS_MOBILE,
];

export const BANKING = "banking";
export const INSURANCE = "insurance";
export const OTHER = "other";
export const FEEDBACK_TARGETS = [BANKING, INSURANCE, OTHER];

export const ANALYTICS_EVENTS = {
  open: { name: "start", description: "vaihe 1, lomake avattu" },
  start: { name: "step", description: "vaihe 2, lomake aloitettu" },
  end: { name: "completed", description: "viimeinen vaihe, lomake lahetetty" },
  error: { name: "error", description: "TechnicalError" },
};

export const LANGUAGES = {
  fi: "fi_fi",
  en: "en_us",
  sv: "sv_se",
};

export const REFRESH_SESSION_INTERVAL = 300000; // 5 minutes
export const MAX_SESSION_TIMEOUT = 60 * 60000; // 60 minutes
export const MODAL_TIMEOUT = 90000; // 90 seconds
export const USER_INACTIVITY_TIMEOUT = 15 * 60000; // 15 minutes
